
import http from "../../axios-config/g-http-metodos";

function getEnumTipoComponente(){
    const { res, erro, requisicao } = http.get('Componente/GetEnumTipoComponente')
    return { TipoComponenteArray: res, erro, requisicao }
}

function getEnumDescricaoAcabamentoFrente(){
    const { res, erro, requisicao } = http.get('Componente/GetEnumDescricaoAcabamentoFrente')
    return { CorFrenteAcabamentoArray: res, erro, requisicao }
}

function getEnumDescricaoCoresFrente(){
    const{res, erro, requisicao} = http.get('Componente/GetEnumDescricaoCoresFrente')
    return {CorFrenteArray: res , erro , requisicao}
}

function getEnumDescricaoCoresVerso(){
    const{res, erro, requisicao} = http.get('Componente/GetEnumDescricaoCoresVerso')
    return {CorVersoArray: res , erro , requisicao}
}

function getEnumDescricaoAcabamentoVerso(){
    const{res, erro, requisicao} = http.get('Componente/GetEnumDescricaoAcabamentoVerso')
    return {CorVersoAcabamentoArray : res , erro ,requisicao}
}

function getEnumDescricaoCapaInterna(){
    const{res , erro , requisicao} = http.get('Componente/GetEnumDescricaoCapaInterna')
    return {CapaInternaArray :res , erro , requisicao}
}

function getEnumDescricaoCapaExterna(){
    const{res , erro , requisicao} = http.get('Componente/GetEnumDescricaoCapaExterna')
    return {CapaExternaArray :res , erro , requisicao}
}

function getEnumDescricaoMaterial(){
    const{res, erro, requisicao} = http.get('Componente/GetEnumDescricaoMaterial')
    return {MaterialArray :res, erro, requisicao}
}

function getEnumDescricaoCapaPapelOnda(){
    const{res , erro ,requisicao} = http.get('Componente/GetEnumDescricaoCapaPapelOnda')
    return {PapelOndaArray :res , erro ,requisicao}
}


function getEnumDescricaoOnda(){
    const{res , erro ,requisicao} = http.get('Componente/GetEnumDescricaoOnda')
    return {OndaArray :res , erro ,requisicao}
}

function getComponentesByOrcamentoId(orcamentoId){
    const{res ,pos ,requisicao} = http.getArray(`Componente/GetComponentesByOrcamentoId/${orcamentoId}`)
    return{ComponenteArray: res ,pos ,requisicao}
}

function getComponentesByProdutoId (produtoId){
    const{res ,pos ,requisicao} = http.get(`Componente/GetComponentesByProdutoId/${produtoId}`)
    return{ProdutoId: res ,pos ,requisicao}
}

function getEnumEnumDescricaoMedida(){
    const{res , erro , requisicao} = http.get('Componente/GetEnumDescricaoMedida')
    return {MedidaConformeArray: res , erro , requisicao}
}

const ComponenteController = {
    getEnumDescricaoAcabamentoFrente,
    getEnumDescricaoAcabamentoVerso,
    getEnumDescricaoCapaExterna,
    getEnumDescricaoCapaInterna,
    getEnumDescricaoCapaPapelOnda,
    getEnumDescricaoCoresFrente,
    getEnumDescricaoCoresVerso,
    getEnumDescricaoMaterial,
    getEnumTipoComponente,
    getComponentesByOrcamentoId,
    getComponentesByProdutoId,
    getEnumDescricaoOnda,
    getEnumEnumDescricaoMedida
}

export default ComponenteController